import React from 'react';
import { CreditCardIcon, FileTextIcon, LayersIcon, LockIcon, ShieldCheckIcon, SparklesIcon, UsersIcon, ZapIcon } from 'lucide-react';
import { heroStats, mockupUrl } from '../data/content';
const badges = [[FileTextIcon, '100% PDF'], [ZapIcon, 'Acceso en 5 min'], [SparklesIcon, 'Principiante → Avanzado'], [LayersIcon, 'Todos los perfiles'], [UsersIcon, 'Atletas de todas las edades']] as const;
export function Hero() {
  return <section className="relative overflow-hidden px-4 pb-14 pt-9 md:pb-20 md:pt-14" data-id="element-176" data-mp="1274orr9pfk8a">
      <div className="pointer-events-none absolute left-1/2 top-[22%] h-[560px] w-[560px] -translate-x-1/2 rounded-full bg-primary/10 blur-[120px]" data-id="element-177" data-mp="xb5w3rhcfg22" />
      <div className="relative mx-auto max-w-5xl text-center" data-id="element-178" data-mp="nczsn5fw21v3">
        <div className="mb-5 inline-flex rounded-full border border-primary/20 bg-primary/10 px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-wider text-primary md:mb-6" data-id="element-179" data-mp="neklmqmk1cqu">
          CompraDigitalYa™
        </div>
        <h1 className="mx-auto max-w-4xl text-[1.75rem] font-black uppercase leading-[1.05] tracking-tight text-ink md:text-[3.6rem]" data-id="element-180" data-mp="3j8sfe0v2xjpu">
          💪 Combo Completo Hipertrofia 2026
        </h1>
        <p className="mx-auto mt-4 max-w-4xl text-xl font-black leading-tight text-primary md:text-4xl" data-id="element-181" data-mp="39alawhhz8u4q">
          Todo tu año de programación de hipertrofia. Listo. Desde hoy.
        </p>

        <a href="#pricing" className="group my-6 flex justify-center rounded-3xl focus:outline-none md:my-8" aria-label="Ver el precio del Combo Completo Hipertrofia 2026" data-id="element-182" data-mp="30i17l3qqq1dk">
          <img className="w-full max-w-[820px] object-contain drop-shadow-[0_26px_44px_rgba(8,23,46,.30)] transition-transform duration-300 ease-out group-hover:scale-[1.015]" src={mockupUrl} alt="Mockup del Combo Completo Hipertrofia 2026 con sus 6 tomos y 5 bonos" data-id="element-183" data-mp="2qk3m2o09mion" />
        </a>

        <p className="mx-auto mt-5 max-w-3xl text-base font-semibold leading-relaxed text-slate-600 md:text-xl" data-id="element-184" data-mp="2ljpcv2mxh2p1">
          <strong className="text-ink" data-id="element-185" data-mp="s2tbjfzvhzn3">
            🇦🇷 EL SISTEMA COMPLETO PARA ENTRENADORES DE GIMNASIO EN ARGENTINA.
          </strong>{' '}
          Principiante → Avanzado, todos los perfiles. Hipertrofia garantizada + adaptaciones para
          cualquier limitación + programas listos para implementar. Sin pasar horas buscando
          ejercicios. Sin improvisar programación. Sin perder tus fines de semana diseñando ciclos.
        </p>

        <div className="mt-6 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs font-semibold text-slate-600 md:text-sm" data-id="element-186" data-mp="161t06nndyej9">
          {badges.map(([BadgeIcon, label]) => <span key={label} className="flex items-center gap-1.5" data-id="element-187" data-mp="114svoh66pju9">
              <BadgeIcon className="h-4 w-4 text-primary" data-id="element-188" data-mp="x0crqlg4smho" />
              {label}
            </span>)}
        </div>

        <div className="mt-7 flex flex-wrap justify-center gap-x-4 gap-y-1 text-[11px] font-semibold text-slate-500 md:text-sm" data-id="element-189" data-mp="3lqugltxj6h7p">
          <span className="flex items-center gap-1" data-id="element-190" data-mp="1x9kwertfdeju">
            <ShieldCheckIcon className="h-3.5 w-3.5 text-primary" data-id="element-191" data-mp="1xb5q6f7x0tgn" />
            Garantía 7 días
          </span>
          <span className="text-primary/30" data-id="element-192" data-mp="218tols8th4da">·</span>
          <span className="flex items-center gap-1" data-id="element-193" data-mp="269r2hsmsnc8z">
            <LockIcon className="h-3.5 w-3.5 text-primary" data-id="element-194" data-mp="26869i7g4o1d8" />
            Pago seguro
          </span>
          <span className="text-primary/30" data-id="element-195" data-mp="2b2kaqqhh12pt">·</span>
          <span className="flex items-center gap-1" data-id="element-196" data-mp="2fyr7ptrw33vm">
            <CreditCardIcon className="h-3.5 w-3.5 text-primary" data-id="element-197" data-mp="2kyvnfhkz3uks" />
            Mercado Pago
          </span>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-3 md:mt-14 md:grid-cols-4" data-id="element-198" data-mp="2ozz4u8io5yo4">
          {heroStats.map(([value, label]) => <div key={label} className="rounded-2xl border border-line bg-white p-4 text-center shadow-sm" data-id="element-199" data-mp="2tyaeoj8ys96c">
              <p className="text-2xl font-black text-primary md:text-3xl" data-id="element-200" data-mp="zlkjzzaruvxw">{value}</p>
              <p className="mt-1 text-[11px] font-bold leading-tight text-slate-500 md:text-sm" data-id="element-201" data-mp="zndrthx4fm7h">
                {label}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}